export {};

declare global {
  interface String {
    removeVietnameseTones(): string;
  }
}

String.prototype.removeVietnameseTones = function (): string {
  return this.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D");
};
